import CategoriaControleReclamacaoModel from "@/models/categoriaControleReclamacaoModel";

import { IService } from "./base/iService";

export default class CategoriaControleReclamacaoService extends IService<CategoriaControleReclamacaoModel> {
    constructor() {
        super("CategoriaControleReclamacao");
    }
}
